import PluginUtils from "../shared/PluginUtils.js";
import MapViewModel from "../shared/models/MapViewerModel.js";
export default {
  id: 'molten.BaseMapViewModelUpdater',
  sort: -1,
  update(model, cxt) {
    const {
      props,
      caches
    } = cxt;
    const {
      objectType,
      path,
      relationship
    } = props;
    const pluginType = cxt.dataViewer.type === 'molten.GoogleMap' ? 'GoogleMapsRenderer' : undefined;
    const client = cxt.dataViewer.type === 'molten.GoogleMap' ? 'GoogleMapsDataViewer' : undefined;
    const plgs = PluginUtils.getRendererPlugins(caches, objectType, path, relationship, pluginType, client);
    if (typeof model?.then === 'function') {
      return model;
    }
    let nModel = model;
    if (model == null || model.type == null || !Array.isArray(model.layers)) {
      nModel = MapViewModel.create();
    } else if (nModel.layers.some(l => l.layerName == null)) {
      // remove unnamed/usused layers...
      const nLayers = nModel.layers.filter(l => l.layerName != null);
      nModel = MapViewModel.setLayers(nModel, nLayers);
    }

    // Make sure we have models for each renderer
    plgs.forEach((plg, index) => {
      const idx = MapViewModel.getLayerIndexByName(nModel, plg.layerName);
      const mdl = idx < 0 ? null : MapViewModel.getLayer(nModel, idx);
      const model = plg.createModel(mdl);
      if (model == null || model.layerName == null) {
        // eslint-disable-next-line no-console
        console.error(`Invalid model returned from MapBoxRenderer.createModel(). 
                          It must be non null and have a layerName`, plg);
        return;
      }
      if (idx >= 0) {
        nModel = MapViewModel.setLayer(nModel, idx, model);
      } else {
        nModel = MapViewModel.addLayer(nModel, model, index); // insert 
      }
    });
    if (plgs.length !== nModel.layers.length) {
      const nLayers = nModel.layers.filter(l => plgs.some(item => item.layerName === l.layerName));
      nModel = MapViewModel.setLayers(nModel, nLayers);
    }
    return nModel;
  }
};